import React, { Component, useEffect } from 'react';
import { BrowserRouter, Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import Home from './Pages/Home';
import News from './Pages/News';
import About from './Pages/About';
import Error from './Pages/Error';
import Partnership from './Pages/Partnership';
import ProjectResults from './Pages/ProjectResults';

// Error boundary to catch rendering errors
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("React Error:", error);
    console.error("Error details:", errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', color: 'red' }}>
          <h2>Something went wrong</h2>
          <p>{this.state.error?.toString()}</p>
          <button onClick={() => window.location.reload()}>Reload Page</button>
        </div>
      );
    }
    return this.props.children;
  }
}

// Component to handle redirects and navigation
const NavigationHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    // Handle potential path issues (like trailing slashes)
    if (location.pathname.endsWith('/') && location.pathname !== '/') {
      navigate(location.pathname.slice(0, -1), { replace: true });
    }
  }, [location, navigate]);
  
  return null;
};

export const App = () => {
  console.log("App component rendering");
  
  return (
    <div>
      <ErrorBoundary>
        <BrowserRouter basename={import.meta.env.BASE_URL || '/'}>
          <NavigationHandler />
          <Routes>
            <Route index element={<Home />} />
            <Route path='/Home' element={<Home />} />
            <Route path='/News' element={<News />} />
            <Route path='/About' element={<About />} />
            <Route path='/Partnership' element={<Partnership />} />
            <Route path='/ProjectResults' element={<ProjectResults />} />
            <Route path='*' element={<Error />} />
          </Routes>
        </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
